import { useEffect } from 'react';
import { useAccountStore } from '../components/account/hooks/useAccountStore';
import { getMemberInfo } from '../repositories/member/MemberRepository';
import { getCookie } from '../util/cookie';
import { useLocation } from 'react-router-dom';

export const useFetchAccountInfo = () => {
  const setData = useAccountStore((state) => state.actions.setData);
  const location = useLocation();
  const token = getCookie('token');
  const isLoginPage = location.pathname.includes('login');
  // 로그인 화면에서 토큰이 생기고 다른 화면으로 넘어올 때도 불러와야 권한 메뉴가 바로 보인다
  useEffect(() => {
    if (!token || isLoginPage) {
      return;
    }

    getMemberInfo().then(({ data: { body } }) => setData(body));
  }, [token, isLoginPage]);
};
